import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MicrosoftDialPlanInventory } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class MicrosoftDialPlanInventoriesResource {
  private http = inject(HttpClient);

  get(tenantId: number | string, dialPlanId: number): Observable<MicrosoftDialPlanInventory> {
    return this.http.get<MicrosoftDialPlanInventory>(
      `/services/microsoft/views/tenants/${tenantId}/dial-plan-inventories/${dialPlanId}`,
    );
  }
}
